<template>
  <Modal class="option-modal" v-on:close="$emit('close')">
    <slot slot="header">
      <h3 v-html="option.name"></h3>
    </slot>
    <slot slot="body">
      <div v-html="option.popup.content"></div>
    </slot>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
  name: "OptionModal",
  components: {
    Modal
  },
  props: {
    option: {
      name: String,
      popup: {
        content: String
      }
    }
  }
};
</script>

<style lang="scss">
.option-modal {
  color: initial;

  img {
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 3px;
  }
}
</style>